<template>
  <el-dialog
    :visible.sync="innerVisible"
    :title="dialogTitle"
    width="720px"
    append-to-body
    custom-class="soc-togo-dialog"
    @close="$emit('close')"
  >
    <p class="soc-togo-sub">{{ dialogSub }}</p>
    <soc-process-rail
      :nodes="railNodes"
      :now-label="$t('route.socProcessNetTogoNow')"
      @select="onRail"
    />
    <p class="soc-togo-hint">{{ $t('route.socProcessNetTogoHint') }}</p>
    <span slot="footer">
      <el-button size="mini" @click="innerVisible = false">{{ $t('route.socProcessNetTogoClose') }}</el-button>
      <el-button type="primary" size="mini" @click="onVoice">{{ $t('route.socProcessNetTogoVoice') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import SocProcessRail from '@/components/SocProcessRail'

export default {
  name: 'SocWorkOrderTogoDialog',
  components: { SocProcessRail },
  props: {
    visible: { type: Boolean, default: false },
    payload: { type: Object, default: null }
  },
  computed: {
    innerVisible: {
      get () {
        return this.visible
      },
      set (v) {
        if (!v) this.$emit('close')
      }
    },
    steps () {
      return (this.payload && this.payload.steps) || []
    },
    railNodes () {
      var list = this.steps
      var out = []
      var i
      for (i = 0; i < list.length; i++) {
        out.push({
          id: list[i].stepId,
          title: this.stepTitle(list[i]),
          done: !!list[i].done,
          stuck: !!list[i].stuck,
          jump: list[i].stepId,
          raw: list[i]
        })
      }
      return out
    },
    dialogTitle () {
      if (this.payload && this.payload.titleZh) return this.payload.titleZh
      return this.$t('route.socProcessNetTogoTitle')
    },
    dialogSub () {
      if (this.payload && this.payload.subtitleZh) return this.payload.subtitleZh
      var n = this.payload && this.payload.toGoCount
      if (n === 0) return this.$t('route.socProcessNetTogoAllDone')
      if (n > 0) return this.$t('route.socProcessNetTogoRemain', { n: n })
      return this.$t('route.socProcessNetTogoHint')
    }
  },
  methods: {
    stepTitle (step) {
      var key = 'x600hProductionOrder.togoStep_' + (step && step.stepId)
      var t = this.$t(key)
      if (t && t !== key) return t
      return (step && step.titleZh) || ''
    },
    onRail (node) {
      this.$emit('jump', (node && node.raw) || node)
    },
    onVoice () {
      var stuck = null
      var i
      for (i = 0; i < this.steps.length; i++) {
        if (this.steps[i].stuck) {
          stuck = this.steps[i]
          break
        }
      }
      this.$emit('voice', stuck || this.steps[0] || null)
    }
  }
}
</script>

<style scoped>
.soc-togo-sub {
  margin: 0 0 12px;
  color: var(--sap-text-secondary, #5b616b);
  font-size: 13px;
}
.soc-togo-hint {
  margin: 12px 0 0;
  font-size: 12px;
  color: #64748b;
}
</style>



// WEBPACK FOOTER //
// src/components/SocWorkOrderTogoDialog.vue